/** Render layer ordering for the 3D map.
 *  Higher numbers render later (on top). Meshes within the same layer
 *  render in JSX tree order. Depth-tested geometry still occludes
 *  correctly regardless of renderOrder.
 */
export const RenderLayer = {
  Terrain: 0,
  Infrastructure: 1,
  Resources: 2,
  Buildings: 3,
  Units: 4,
  Effects: 5,
  UI: 6,
} as const;

export type RenderLayer = (typeof RenderLayer)[keyof typeof RenderLayer];
